import { Component, Prop, Watch } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { IConnectionNotificationSettings } from '@/components/shared-components/connection-notification/_domain/connection-notification-settings';
import { IBaseServerService, ServerServiceSubscriptionStore } from '@/app-modules/server-service';
import { IRetryPolicySettings } from '@/app-modules/server-communications';

@Component({
  name: 'ConnectionNotificationComponent'
})
class ConnectionNotificationComponent extends TombolaBaseComponent {
  @Prop() public server: IBaseServerService;
  @Prop() public retryPolicySettings: IRetryPolicySettings;
  private notificationSettings: IConnectionNotificationSettings = null;
  private isFirstConnection: boolean = true;
  private serverSubscriptionStore: ServerServiceSubscriptionStore = null;

  private mounted() {
    if (this.server) {
      this.subscribeToConnectionNotificationStreams();
    }
  }

  @Watch('server')
  private serverInitialised(): void {
    this.subscribeToConnectionNotificationStreams();
  }

  private beforeDestroy() {
    this.unsubscribeFromConnectionNotificationStreams();
  }

  public subscribeToConnectionNotificationStreams() {
    this.serverSubscriptionStore = new ServerServiceSubscriptionStore(
      this.server.subscribeConnecting(() => this.onConnecting()),
      this.server.subscribeConnected(() => this.onConnected()),
      this.server.subscribeConnectionLost(() => this.onConnectionLost()),
      this.server.subscribeRetryCircuitBroken(() => this.onRetryCircuitBroken())
    );
  }

  private unsubscribeFromConnectionNotificationStreams() {
    if (this.serverSubscriptionStore) {
      this.serverSubscriptionStore.unsubscribeAll();
    }
  }

  private connectingNotification: IConnectionNotificationSettings = {
    cssClass: 'warning',
    message: this.$lang.connection.message.attemptingReconnect,
    dismissible: false,
    manualRetryOption: false,
    iconClass: 'fa fa-spinner fa-pulse fa-fw'
  };

  private disconnectedNotification: IConnectionNotificationSettings = {
    cssClass: 'danger',
    message: this.$lang.connection.message.disconnected,
    dismissible: false,
    manualRetryOption: true,
    iconClass: 'fa fa-plug'
  };

  private awaitingRetryNotification: IConnectionNotificationSettings = {
    cssClass: 'warning',
    message: this.$lang.connection.message.lostConnectionAwaitingRetry,
    dismissible: false,
    manualRetryOption: false,
    iconClass: 'fa fa-plug'
  };

  private onConnecting() {
    if ( !this.isFirstConnection ) {
      this.notificationSettings = this.connectingNotification;
    }
  }

  private onConnected() {
    this.notificationSettings = null;
    this.isFirstConnection = false;
  }

  private onConnectionLost() {
    this.notificationSettings = this.retryPolicySettings.enabled ? this.awaitingRetryNotification : this.disconnectedNotification;
  }

  private onRetryCircuitBroken() {
    this.notificationSettings = this.disconnectedNotification;
  }

  private attemptReconnect() {
    if (this.disconnectedNotification.manualRetryOption) {
      this.notificationSettings = this.connectingNotification;
      this.server.connect();
    }
  }
}

export default ConnectionNotificationComponent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/shared-components/connection-notification/connection-notification.component.ts